let url;
function createUrlObject() {
  // return a dummy URL object for Node environment.
  // Node environment does not need proxying.
  if (typeof window === "undefined") {
    throw new Error(
      "`getApiProxyOrigin()` and `getApiProxyPath()` are not supported for NodeJS."
    );
  }
  const location = isLocalhost()
    ? window.location.host
    : `io.${window.location.host}`;
  try {
    // Get the proxy from the REACT_APP_API_PROXY. Handle either a full URL, or a root-relative URL (`/something`).
    if (typeof process.env.REACT_APP_API_PROXY !== "string") {
      throw new Error("process.env.REACT_APP_API_PROXY isn't a string");
    } else if (
      process.env.REACT_APP_API_PROXY.startsWith("http://") ||
      process.env.REACT_APP_API_PROXY.startsWith("https://")
    ) {
      url = new URL(process.env.REACT_APP_API_PROXY);
    } else if (process.env.REACT_APP_API_PROXY.startsWith("/")) {
      url = new URL(
        process.env.REACT_APP_API_PROXY,
        `${window.location.protocol}//${location}`
      );
    } else {
      throw new Error(
        "process.env.REACT_APP_API_PROXY is not formatted correctly (value is " +
          JSON.stringify(process.env.REACT_APP_API_PROXY) +
          ")"
      );
    }
  } catch (ex) {
    let NODE_ENV = "production";
    try {
      if (process.env.NODE_ENV) {
        NODE_ENV = process.env.NODE_ENV;
      }
    } catch (ex) {}
    if (NODE_ENV === "test" || NODE_ENV === "ut") {
      url = new URL("http://example.com/proxy");
    } else {
      // tslint:disable-next-line: no-console
      console.error(ex);
      // tslint:disable-next-line: no-console
      console.error(
        "The web-api-clients will use `/proxy` as " +
          "the proxy URL because process.env.REACT_APP_API_PROXY is invalid or not set. " +
          "This was probably unintended and due to a misconfigured consuming app."
      );
      url = new URL("/proxy", `${window.location.protocol}//${location}`);
    }
  }
}
export function getApiProxyOrigin() {
  if (url === undefined) {
    createUrlObject();
  }
  return `${url.protocol}//${url.hostname}:${url.port}`;
}
export function getApiProxyPath() {
  if (url === undefined) {
    createUrlObject();
  }
  return url.pathname;
}
function isLocalhost() {
  if (window.location.host === undefined) return true;
  return (
    window.location.host.startsWith("local") || // local.<host> or localhost
    window.location.host.startsWith("127.0.0.1") ||
    window.location.host.startsWith("0.0.0.0")
  );
}
